// extracted by mini-css-extract-plugin
module.exports = {"AutomatedTime":"AutomatedTime_AutomatedTime__krtBc"};